import { computed, defineComponent, inject } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

const PRODUCT_ID_MOBILE_PORTING = 31;
const PRODUCT_ID_MOBILE_NEW = 37;

const SELECTION_NEW = "new";
const SELECTION_PORTING = "porting";

export default defineComponent({
  template: html,
  setup() {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);

    // vars und computed
    const portingItem = computed(() => {
      return orderService?.currentItems?.value?.find((it) => it.product_id == PRODUCT_ID_MOBILE_PORTING) ?? null;
    });
    const newItem = computed(() => {
      return orderService?.currentItems?.value?.find((it) => it.product_id == PRODUCT_ID_MOBILE_NEW) ?? null;
    });

    const portingVariant = computed(() => {
      return orderService?.availableVariants?.value?.find(
        (v) => v.product_id == PRODUCT_ID_MOBILE_PORTING && v.qty_price_for == 0,
      ) ?? null;
    });
    const newVariant = computed(() => {
      return orderService?.availableVariants?.value?.find(
        (v) => v.product_id == PRODUCT_ID_MOBILE_NEW && v.qty_price_for == 0,
      ) ?? null;
    });

    const selection = computed(() => {
      if (0 < (portingItem.value?.qty ?? 0)) {
        return SELECTION_PORTING;
      }
      if (0 < (newItem.value?.qty ?? 0)) {
        return SELECTION_NEW;
      }
      return null;
    });

    // methods
    const onSelectionChange = async (value: string) => {
      if (value == selection.value) {
        return;
      }
      if (SELECTION_NEW == value) {
        const removeQty = portingItem.value?.qty ?? 0;
        if (0 < removeQty && portingVariant.value) {
          await orderService?.removeFromCart(portingVariant.value.id, "", removeQty);
        }
        if (newVariant.value) {
          await orderService?.addToCart(newVariant.value.id, "", 1);
        }
      } else if (SELECTION_PORTING == value) {
        const removeQty = newItem.value?.qty ?? 0;
        if (0 < removeQty && newVariant.value) {
          await orderService?.removeFromCart(newVariant.value.id, "", removeQty);
        }
        if (portingVariant.value) {
          await orderService?.addToCart(portingVariant.value.id, "", 1);
        }
      }
    };

    return {
      t,
      selection,
      onSelectionChange,
    };
  },
} as any);
